/* See it in your space · Sissonne Outdoor */
(function(){

let PRODUCTS=[];
const imgs={};
const cv=document.getElementById('siys-stage'),ctx=cv.getContext('2d');
const $=id=>document.getElementById('siys-'+id);
const CFG=JSON.parse(document.getElementById('siys-config').textContent);
const CUT=CFG.cutouts;
let bg=null,items=[],sel=null,nextId=1,drag=null,horizon=.3,guideOn=false;
const SCENE_SETSCALE={'olive-grove-courtyard':.8,'poolside-terrace':.52,'hillside-terrace':.66};
const SCENE_HORIZON={'olive-grove-courtyard':.47,'poolside-terrace':.05,'hillside-terrace':.32};
const FILTER_OK=typeof ctx.filter==='string';
const prod=id=>PRODUCTS.find(p=>p.id===id);
const variant=it=>prod(it.pid).colours[it.ci].angles[it.vi];
const soldOut=(p,ci)=>p.colours[ci]&&p.colours[ci].available===false;
const money=n=>'$'+n.toLocaleString('en-AU',{minimumFractionDigits:2,maximumFractionDigits:2});
/* px-per-cm of an item at its current size, so every piece shares one real-world scale */
const scaleOf=it=>it.h*prod(it.pid).pxPerCm/variant(it).oh;
function heightFor(pid,ci,vi,s){const p=prod(pid);return s*p.colours[ci].angles[vi].oh/p.pxPerCm;}
function load(src){return new Promise(r=>{const i=new Image();i.onload=()=>r(i);i.onerror=()=>r(null);i.src=src;});}
const atlasP={};
function loadAtlas(i){return atlasP[i]||(atlasP[i]=load(CFG.atlases[i]));}
function ensure(keys){return Promise.all(keys.map(k=>{if(imgs[k])return imgs[k];const m=CUT.m[k];if(!m)return null;return loadAtlas(m[0]).then(im=>{if(im)imgs[k]={img:im,r:m.slice(1)};return imgs[k];});}));}
const colourKeys=(pid,ci)=>prod(pid).colours[ci].angles.map(a=>a.key);

/* ---------- sample courtyard ---------- */
function sampleScene(){
  const W=1500,H=1000,c=document.createElement('canvas');c.width=W;c.height=H;const g=c.getContext('2d');
  const hz=H*.47;
  let gr=g.createLinearGradient(0,0,0,hz);gr.addColorStop(0,'#e3e0d9');gr.addColorStop(1,'#cfcac0');g.fillStyle=gr;g.fillRect(0,0,W,hz);
  for(let x=W*.56;x<W;x+=22){g.fillStyle=((x/22)|0)%2?'#8a6a4c':'#7d5f43';g.fillRect(x,H*.06,16,hz-H*.06);}
  g.fillStyle='rgba(0,0,0,.12)';g.fillRect(W*.56,hz-14,W*.44,14);
  gr=g.createLinearGradient(0,0,0,H*.06);gr.addColorStop(0,'#b9d0de');gr.addColorStop(1,'#d7e3ea');g.fillStyle=gr;g.fillRect(W*.56,0,W*.44,H*.06);
  g.fillStyle='#a19d94';g.fillRect(0,hz-110,W*.5,110);
  for(let i=0;i<1400;i++){const x=Math.random()*W*.5,y=hz-110-Math.random()*160;g.fillStyle=`hsl(${95+Math.random()*30},${28+Math.random()*20}%,${16+Math.random()*20}%)`;g.beginPath();g.arc(x,y+Math.random()*40,6+Math.random()*12,0,7);g.fill();}
  g.fillStyle='#aeaaa1';g.fillRect(0,hz-112,W*.5,8);
  gr=g.createLinearGradient(0,hz,0,H);gr.addColorStop(0,'#b0b1ac');gr.addColorStop(1,'#93948f');g.fillStyle=gr;g.fillRect(0,hz,W,H-hz);
  const vx=W*.45,vy=hz-900;g.strokeStyle='rgba(60,62,60,.3)';g.lineWidth=2;
  for(let i=-30;i<=30;i++){const bx=vx+i*130;g.beginPath();g.moveTo(vx+(bx-vx)*((hz-vy)/(H*1.6-vy)),hz);g.lineTo(bx,H*1.6);g.stroke();}
  let y=hz,step=18;while(y<H){g.beginPath();g.moveTo(0,y);g.lineTo(W,y);g.stroke();y+=step;step*=1.28;}
  for(let i=0;i<5000;i++){g.fillStyle=`rgba(255,255,255,${Math.random()*.06})`;g.fillRect(Math.random()*W,hz+Math.random()*(H-hz),2,2);}
  gr=g.createRadialGradient(W*.25,H*.2,50,W*.25,H*.2,W*.9);gr.addColorStop(0,'rgba(255,240,210,.18)');gr.addColorStop(1,'rgba(0,0,0,.1)');g.fillStyle=gr;g.fillRect(0,0,W,H);
  return c;
}
function setBackground(src){
  const W=src.naturalWidth||src.width,H=src.naturalHeight||src.height,s=Math.min(1800/Math.max(W,H),Math.max(1,1400/W));
  const oW=cv.width,oH=cv.height;cv.width=Math.round(W*s);cv.height=Math.round(H*s);
  items.forEach(it=>{it.x*=cv.width/oW;it.y*=cv.height/oH;it.h*=cv.height/oH;});
  bg=src;syncCtrls();draw();
}

/* ---------- geometry (x,y = bottom centre; rotation pivots on the piece's centre) ---------- */
function dims(it){const a=variant(it);return{w:it.h*a.ow/a.oh,h:it.h};}
function pivot(it){return{x:it.x,y:it.y-it.h/2};}
function toWorld(it,lx,ly){const p=pivot(it),a=it.rot*Math.PI/180;return{x:p.x+lx*Math.cos(a)-ly*Math.sin(a),y:p.y+lx*Math.sin(a)+ly*Math.cos(a)};}
function toLocal(it,wx,wy){const p=pivot(it),a=-it.rot*Math.PI/180,dx=wx-p.x,dy=wy-p.y;return{x:dx*Math.cos(a)-dy*Math.sin(a),y:dx*Math.sin(a)+dy*Math.cos(a)};}
function handleR(){return Math.max(14,cv.width/70);}
function handles(it){const d=dims(it);return{size:toWorld(it,d.w/2,-d.h/2),rot:toWorld(it,0,-d.h/2-handleR()*3),turn:toWorld(it,0,d.h/2+handleR()*2.4)};}
/* Turn sequence: walk round the piece using the studio angles, mirroring the far side */
function turnSeq(it){
  const A=prod(it.pid).colours[it.ci].angles,idx=l=>A.findIndex(a=>a.label===l);
  const F=idx('Front'),AF=idx('Angled front'),S=idx('Side'),AB=idx('Angled back'),B=idx('Back');
  let s=[[F,false],[AF,false],[S,false],[AB,false],[B,false],[AB,true],[S,true],[AF,true]].filter(x=>x[0]>=0);
  if(s.length<2)s=A.map((a,i)=>[i,false]).concat(A.map((a,i)=>[i,true]).reverse());
  return s;
}
function turnTo(it,vi,flip){const s=scaleOf(it);it.vi=vi;it.flip=flip;it.h=heightFor(it.pid,it.ci,vi,s);ensure([variant(it).key]).then(draw);}
function turnStep(it,dir){const s=turnSeq(it);let i=s.findIndex(x=>x[0]===it.vi&&x[1]===it.flip);if(i<0)i=0;const n=s[(i+dir+s.length)%s.length];turnTo(it,n[0],n[1]);syncCtrls();draw();}

/* ---------- items ---------- */
function addItem(pid,opts={}){
  const ref=sel||items[items.length-1];
  const base={uid:nextId++,pid,ci:0,vi:0,x:cv.width*(.35+Math.random()*.3),y:ref?ref.y:cv.height*.85,rot:0,flip:false,light:100,warm:0,shadow:45};
  const s=ref?scaleOf(ref):cv.height*.42/80; // default: an 80cm-tall chair fills ~42% of the photo
  const it=Object.assign(base,opts);
  if(opts.h==null)it.h=heightFor(pid,it.ci,it.vi,s);
  items.push(it);select(it);draw();renderPlaced();return it;
}
function draw(){
  ctx.clearRect(0,0,cv.width,cv.height);
  if(bg)ctx.drawImage(bg,0,0,cv.width,cv.height);
  items.forEach(it=>drawItem(ctx,it));
  if(guideOn&&!draw.exporting)drawGuide();
  if(sel&&!draw.exporting)drawSelection(sel);
}
function drawItem(g,it){
  const d=dims(it),im=imgs[variant(it).key];
  if(!im){ensure([variant(it).key]).then(draw);return;}
  if(it.shadow>0){
    const sw=d.w*.95,sh=Math.max(6,d.w*.14),base=toWorld(it,0,d.h/2);
    g.save();g.translate(base.x,base.y-sh*.15);g.rotate(it.rot*Math.PI/180);g.scale(1,sh/sw);
    const gr=g.createRadialGradient(0,0,0,0,0,sw/2);
    gr.addColorStop(0,`rgba(0,0,0,${.6*it.shadow/100})`);gr.addColorStop(.6,`rgba(0,0,0,${.25*it.shadow/100})`);gr.addColorStop(1,'rgba(0,0,0,0)');
    g.fillStyle=gr;g.beginPath();g.arc(0,0,sw/2,0,7);g.fill();g.restore();
  }
  g.save();
  if(FILTER_OK){const w=it.warm;g.filter=`brightness(${it.light/100}) sepia(${Math.max(0,w)/100}) saturate(${1+w/100}) hue-rotate(${w<0?-w*.6:0}deg)`;}
  const p=pivot(it);g.translate(p.x,p.y);g.rotate(it.rot*Math.PI/180);if(it.flip)g.scale(-1,1);
  g.drawImage(im.img,im.r[0],im.r[1],im.r[2],im.r[3],-d.w/2,-d.h/2,d.w,d.h);g.restore();
}
function drawSelection(it){
  const d=dims(it),p=pivot(it),lw=Math.max(2,cv.width/600),r=handleR(),hs=handles(it);
  ctx.save();ctx.translate(p.x,p.y);ctx.rotate(it.rot*Math.PI/180);
  ctx.setLineDash([lw*4,lw*3]);ctx.lineWidth=lw;ctx.strokeStyle='#ffffff';ctx.shadowColor='rgba(0,0,0,.5)';ctx.shadowBlur=4;
  ctx.strokeRect(-d.w/2,-d.h/2,d.w,d.h);ctx.setLineDash([]);
  ctx.beginPath();ctx.moveTo(0,-d.h/2);ctx.lineTo(0,-d.h/2-r*2);ctx.stroke();ctx.restore();
  // handles
  // turn handle: a pill under the piece with left/right arrows
  {const h=hs.turn,w=r*2.6;ctx.save();ctx.fillStyle='#ffffff';ctx.shadowColor='rgba(0,0,0,.4)';ctx.shadowBlur=5;ctx.beginPath();ctx.roundRect(h.x-w,h.y-r*.85,w*2,r*1.7,r*.85);ctx.fill();ctx.restore();
   ctx.save();ctx.strokeStyle='#a0552b';ctx.lineWidth=lw*1.4;ctx.translate(h.x,h.y);ctx.beginPath();
   ctx.moveTo(-w*.7,0);ctx.lineTo(w*.7,0);ctx.moveTo(-w*.7+r*.35,-r*.35);ctx.lineTo(-w*.7,0);ctx.lineTo(-w*.7+r*.35,r*.35);ctx.moveTo(w*.7-r*.35,-r*.35);ctx.lineTo(w*.7,0);ctx.lineTo(w*.7-r*.35,r*.35);ctx.stroke();ctx.restore();}
  [['size',hs.size],['rot',hs.rot]].forEach(([k,h])=>{
    ctx.save();ctx.fillStyle='#ffffff';ctx.shadowColor='rgba(0,0,0,.4)';ctx.shadowBlur=5;ctx.beginPath();ctx.arc(h.x,h.y,r,0,7);ctx.fill();ctx.restore();
    ctx.save();ctx.strokeStyle='#a0552b';ctx.lineWidth=lw*1.4;ctx.translate(h.x,h.y);
    if(k==='size'){ctx.rotate(it.rot*Math.PI/180);ctx.beginPath();ctx.moveTo(-r*.45,r*.45);ctx.lineTo(r*.45,-r*.45);ctx.moveTo(r*.05,-r*.45);ctx.lineTo(r*.45,-r*.45);ctx.lineTo(r*.45,-r*.05);ctx.stroke();}
    else{ctx.beginPath();ctx.arc(0,0,r*.48,-Math.PI*.15,Math.PI*1.35);ctx.stroke();const a=Math.PI*1.35,ex=Math.cos(a)*r*.48,ey=Math.sin(a)*r*.48;ctx.beginPath();ctx.moveTo(ex,ey);ctx.lineTo(ex+r*.3,ey+r*.02);ctx.moveTo(ex,ey);ctx.lineTo(ex+r*.05,ey-r*.3);ctx.stroke();}
    ctx.restore();
  });
}

/* ---------- pointer interaction ---------- */
function pt(e){const r=cv.getBoundingClientRect();return{x:(e.clientX-r.left)*cv.width/r.width,y:(e.clientY-r.top)*cv.height/r.height};}
function hit(p){for(let i=items.length-1;i>=0;i--){const it=items[i],d=dims(it),l=toLocal(it,p.x,p.y);if(Math.abs(l.x)<=d.w/2&&Math.abs(l.y)<=d.h/2)return it;}return null;}
function onHandle(p){if(guideOn&&Math.abs(p.y-cv.height*horizon)<handleR()*1.2)return'hz';if(!sel)return null;const hs=handles(sel),r=handleR()*1.8;if(Math.abs(p.x-hs.turn.x)<handleR()*3&&Math.abs(p.y-hs.turn.y)<handleR()*1.3)return'turn';if(Math.hypot(p.x-hs.rot.x,p.y-hs.rot.y)<r)return'rot';if(Math.hypot(p.x-hs.size.x,p.y-hs.size.y)<r)return'size';return null;}
cv.addEventListener('pointerdown',e=>{
  const p=pt(e),h=onHandle(p);
  if(h==='hz'){drag={mode:'hz'};cv.setPointerCapture(e.pointerId);return;}
  if(h==='size'){const pv=pivot(sel);drag={mode:'size',it:sel,d0:Math.hypot(p.x-pv.x,p.y-pv.y),h0:sel.h,by:sel.y};}
  else if(h==='turn'){const s=turnSeq(sel);let i=s.findIndex(x=>x[0]===sel.vi&&x[1]===sel.flip);drag={mode:'turn',it:sel,x0:p.x,i0:i<0?0:i,seq:s,step:Math.max(28,cv.width/40)};}
  else if(h==='rot'){const pv=pivot(sel);drag={mode:'rot',it:sel,a0:Math.atan2(p.y-pv.y,p.x-pv.x),r0:sel.rot};}
  else{const it=hit(p);select(it);if(it)drag={mode:'move',it,dx:p.x-it.x,dy:p.y-it.y};}
  if(drag)cv.setPointerCapture(e.pointerId);draw();
});
cv.addEventListener('pointermove',e=>{
  const p=pt(e);
  if(!drag){const h=onHandle(p);cv.style.cursor=h==='hz'?'ns-resize':h==='turn'?'ew-resize':h==='rot'?'grab':h==='size'?'nwse-resize':hit(p)?'move':'default';return;}
  if(drag.mode==='hz'){horizon=Math.min(.9,Math.max(.05,p.y/cv.height));draw();return;}
  const it=drag.it;
  if(drag.mode==='move'){
    const hz=cv.height*horizon,ny=Math.max(hz+cv.height*.04,p.y-drag.dy);
    if(ny!==it.y){const k=(ny-hz)/(it.y-hz);if(k>0.2&&k<5)it.h=Math.max(30,it.h*k);} // further back = smaller
    it.x=p.x-drag.dx;it.y=ny;
  }else if(drag.mode==='size'){
    const pv={x:it.x,y:drag.by-drag.h0/2},d=Math.hypot(p.x-pv.x,p.y-pv.y);
    const nh=Math.max(30,drag.h0*d/drag.d0);it.y=drag.by-(drag.h0-nh)/2;it.h=nh; // grow around centre
  }else if(drag.mode==='turn'){
    const s=drag.seq,k=Math.round((p.x-drag.x0)/drag.step),n=s[((drag.i0+k)%s.length+s.length)%s.length];
    if(n[0]!==it.vi||n[1]!==it.flip)turnTo(it,n[0],n[1]);
  }else{
    const pv=pivot(it);let r=drag.r0+(Math.atan2(p.y-pv.y,p.x-pv.x)-drag.a0)*180/Math.PI;
    r=((r+540)%360)-180;if(Math.abs(r)<3)r=0;it.rot=Math.round(r);
  }
  syncCtrls();draw();
});
cv.addEventListener('dblclick',e=>{const it=hit(pt(e));if(it){select(it);turnStep(it,1);}});
['pointerup','pointercancel'].forEach(t=>cv.addEventListener(t,()=>{drag=null;}));

/* ---------- controls ---------- */
function select(it){sel=it;syncCtrls();}
function syncCtrls(){
  const c=$('ctrl');
  if(!sel){c.setAttribute('aria-disabled','true');$('selName').textContent='Tap a piece to select it';$('angles').innerHTML='';return;}
  c.setAttribute('aria-disabled','false');
  const p=prod(sel.pid);$('selName').textContent=p.name+' · '+p.colours[sel.ci].name;
  const swap=(ci,vi)=>{ensure(colourKeys(sel.pid,ci)).then(draw);const s=scaleOf(sel),oh=sel.h,nh=heightFor(sel.pid,ci,vi,s);sel.ci=ci;sel.vi=vi;sel.h=nh;syncCtrls();draw();renderPlaced();};
  const cb=$('colours');cb.innerHTML='';
  p.colours.forEach((c,i)=>{const b=document.createElement('button');b.type='button';b.className='chip';b.textContent=c.name;b.setAttribute('aria-pressed',i===sel.ci);b.onclick=()=>swap(i,sel.vi);cb.appendChild(b);});
  const box=$('angles');box.innerHTML='';
  p.colours[sel.ci].angles.forEach((v,i)=>{const b=document.createElement('button');b.type='button';b.className='chip';b.textContent=v.label;b.setAttribute('aria-pressed',i===sel.vi);b.onclick=()=>swap(sel.ci,i);box.appendChild(b);});
  $('size').max=Math.round(cv.height*1.2);
  set('rot',sel.rot,sel.rot+'°');set('size',Math.round(sel.h),Math.round(sel.h/cv.height*100)+'%');
  set('light',sel.light,sel.light);set('warm',sel.warm,sel.warm);set('shadow',sel.shadow,sel.shadow);
}
function set(id,v,label){$(id).value=v;$(id+'Out').textContent=label;}
[['rot','rot'],['light','light'],['warm','warm'],['shadow','shadow']].forEach(([id,k])=>$(id).addEventListener('input',e=>{if(sel){sel[k]=+e.target.value;syncCtrls();draw();}}));
$('size').addEventListener('input',e=>{if(sel){const nh=+e.target.value;sel.y-=(sel.h-nh)/2;sel.h=nh;syncCtrls();draw();}});
$('flipBtn').onclick=()=>{if(sel){sel.flip=!sel.flip;draw();}};
$('dupBtn').onclick=()=>{if(sel){const {uid,...rest}=sel;addItem(sel.pid,Object.assign({},rest,{x:sel.x+dims(sel).w*.9}));}};
$('frontBtn').onclick=()=>{if(sel){items=items.filter(i=>i!==sel);items.push(sel);draw();}};
$('delBtn').onclick=()=>{if(sel){items=items.filter(i=>i!==sel);select(null);draw();renderPlaced();}};
$('clearBtn').onclick=()=>{items=[];select(null);draw();renderPlaced();};
document.addEventListener('keydown',e=>{
  if(!sel||/INPUT|TEXTAREA|BUTTON/.test(document.activeElement.tagName))return;
  if(e.key==='Delete'||e.key==='Backspace'){$('delBtn').click();e.preventDefault();}
  if(e.key==='ArrowLeft'||e.key==='ArrowRight'){turnStep(sel,e.key==='ArrowRight'?1:-1);e.preventDefault();}
  if(e.key==='['||e.key===']'){sel.rot=Math.max(-180,Math.min(180,sel.rot+(e.key===']'?5:-5)));syncCtrls();draw();}
});

function renderPlaced(){
  const ul=$('placed');ul.innerHTML='';
  const lines=selection();
  if(!lines.length){ul.innerHTML='<li class="empty">Nothing placed yet. Add a piece in step 2.</li>';$('total').innerHTML='';$('cartBtn').setAttribute('aria-disabled','true');return;}
  let sum=0;
  lines.forEach(l=>{sum+=l.qty*l.price;const li=document.createElement('li');
    li.innerHTML=`<span class="nm"><span>${l.p.name}</span><span class="hint">${l.colour} · ${money(l.price)} each${l.available===false?' · <b>sold out</b>':''}</span></span><span class="rt"><span>× ${l.qty}</span><a href="${l.p.url}" target="_blank" rel="noopener">View</a></span>`;ul.appendChild(li);});
  $('total').innerHTML=`<span>Total</span><span>${money(sum)}</span>`;
  $('cartBtn').setAttribute('aria-disabled',lines.some(l=>l.vid&&l.available!==false)?'false':'true');
}
function selection(){const m=new Map();items.forEach(i=>{const p=prod(i.pid),col=p.colours[i.ci],k=i.pid+'|'+col.name;if(!m.has(k))m.set(k,{p,colour:col.name,price:col.price,vid:col.vid,available:col.available,qty:0});m.get(k).qty++;});return [...m.values()];}
const CATS=[['All',null],['Sofas',['Sofa','Day Bed']],['Lounge chairs',['Lounge Chair','Lounge Swivel','Foot Stool']],['Dining chairs',['Dining Chair']],['Dining tables',['Dining Table']],['Coffee tables',['Coffee Table']],['Side tables',['Side Table']],['Sunlounges',['Sunlounge','Sunlounger']],['Bar & counter',['Bar Stool','Counter Stool','Bar Table']]];
let cat='All',q='',rng='';
/* range = collection name at the start of the product title, e.g. Blueys, Jan Juc */
const rangeOf=p=>{const w=p.name.replace(/^Janjuc\b/i,'Jan Juc').split(' '),two=w.slice(0,2).join(' ');return['Jan Juc','Little Cove'].includes(two)?two:w[0];};
function renderRanges(){const sel=$('range');if(!sel)return;const names=[...new Set(PRODUCTS.map(rangeOf))].sort();
  sel.innerHTML='<option value="">All ranges</option>'+names.map(n=>`<option>${n}</option>`).join('');sel.value=rng;}
function renderCats(){const box=$('cats');box.innerHTML='';CATS.forEach(([n,types])=>{if(types&&!PRODUCTS.some(p=>types.includes(p.type)))return;const b=document.createElement('button');b.type='button';b.className='chip';b.textContent=n;b.setAttribute('aria-pressed',n===cat);b.onclick=()=>{cat=n;renderCats();renderProds();};box.appendChild(b);});}
function renderProds(){
  const box=$('prods');box.innerHTML='';
  const types=(CATS.find(c=>c[0]===cat)||[])[1];
  const list=PRODUCTS.filter(p=>(!types||types.includes(p.type))&&(!rng||rangeOf(p)===rng)&&(!q||(p.name+' '+p.type+' '+p.colours.map(c=>c.name).join(' ')).toLowerCase().includes(q)));
  list.sort((a,b)=>rangeOf(a).localeCompare(rangeOf(b))||a.name.localeCompare(b.name));
  $('count').textContent=list.length+(list.length===1?' piece':' pieces');
  if(!list.length){box.innerHTML='<p class="empty">No pieces match. Try All ranges, or a collection name such as Blueys or Mollymook.</p>';return;}
  list.forEach(p=>{
    const prices=p.colours.map(c=>c.price),lo=Math.min(...prices),hi=Math.max(...prices);
    const b=document.createElement('button');b.className='prod';b.type='button';b.id='add-'+p.id;
    b.innerHTML=`<div class="thumb">${p.thumb?`<img loading="lazy" src="${p.thumb}" alt="">`:""}</div><b>${p.name}</b><span class="price">${lo===hi?'':'From '}${money(lo)}</span><span>${p.colours.length>1?p.colours.length+' colours':p.colours[0].name==='Standard'?'':p.colours[0].name}</span><span class="add">+ Add to photo</span>`;
    b.onclick=async()=>{await ensure(colourKeys(p.id,0));addItem(p.id);toast(p.name+' added. Drag it into place.');};
    box.appendChild(b);
  });
}
$('search').addEventListener('input',e=>{q=e.target.value.trim().toLowerCase();renderProds();});
$('range').addEventListener('change',e=>{rng=e.target.value;renderProds();});

/* ---------- photo upload ---------- */
function useFile(f){
  if(!f||!f.type.startsWith('image/')){toast('That file is not an image. Choose a JPG or PNG photo.');return;}
  const im=new Image();
  im.onload=()=>{scene=null;horizon=.45;renderScenes();if(!guideOn)toggleGuide(true);setBackground(im);$('hint').textContent='Your photo is loaded. Drag pieces into place, then use the round handles to resize and rotate.';};
  im.onerror=()=>toast('This browser could not open that photo. Try saving it as a JPG first.');
  im.src=URL.createObjectURL(f);
}
$('file').addEventListener('change',e=>useFile(e.target.files[0]));
const SCENES=[['olive-grove-courtyard','Olive Grove Courtyard'],['poolside-terrace','Poolside Terrace'],['hillside-terrace','Hillside Terrace']];
let scene=null;
function renderScenes(){const box=$('scenes');box.innerHTML='';SCENES.forEach(([k,n])=>{const b=document.createElement('button');b.type='button';b.className='scene';b.setAttribute('aria-label',n);b.title=n;b.setAttribute('aria-pressed',k===scene);b.innerHTML=`<img src="${CFG.scenes[k+'-thumb']}" alt=""><span>${n}</span>`;b.onclick=()=>useScene(k);box.appendChild(b);});}
async function useScene(k){const im=await load(CFG.scenes[k]);if(!im){toast('That sample space could not load. Try another.');return;}scene=k;horizon=SCENE_HORIZON[k]||.45;setBackground(im);renderScenes();$('hint').textContent='Drag a piece to move it. Drag the arrows under it to turn it, or double-click it. Sample space shown.';}
const sw=$('stageWrap');
['dragenter','dragover'].forEach(t=>sw.addEventListener(t,e=>{e.preventDefault();sw.classList.add('drag');}));
['dragleave','drop'].forEach(t=>sw.addEventListener(t,e=>{e.preventDefault();sw.classList.remove('drag');}));
sw.addEventListener('drop',e=>useFile(e.dataTransfer.files[0]));

/* ---------- save / enquire ---------- */
$('saveBtn').onclick=()=>{
  draw.exporting=true;draw();
  const fs=Math.max(14,cv.width/60);ctx.save();ctx.font=`400 ${fs}px Jost, sans-serif`;ctx.fillStyle='rgba(255,255,255,.9)';ctx.shadowColor='rgba(0,0,0,.5)';ctx.shadowBlur=4;
  ctx.textAlign='right';ctx.fillText('SISSONNE OUTDOOR · VISUALISATION ONLY',cv.width-fs,cv.height-fs);ctx.restore();
  $('outImg').src=cv.toDataURL('image/jpeg',.9);draw.exporting=false;draw();$('modal').hidden=false;
};
$('closeModal').onclick=()=>$('modal').hidden=true;
$('modal').addEventListener('click',e=>{if(e.target.id==='siys-modal')$('modal').hidden=true;});
$('enqBtn').onclick=()=>{
  const sel_=selection();
  if(!sel_.length){toast('Add a piece first.');return;}
  const sum=sel_.reduce((a,l)=>a+l.qty*l.price,0);
  const text='Hi Sissonne, I\'m interested in:\n'+sel_.map(l=>`${l.qty} × ${l.p.name}, ${l.colour} (${money(l.price)} each)`).join('\n')+`\nTotal: ${money(sum)}`;
  navigator.clipboard.writeText(text).then(()=>toast('Copied. Paste it into your enquiry.'),()=>toast(text.replace(/\n/g,' · ')));
};
let tt;function toast(m){const t=$('toast');t.textContent=m;t.hidden=false;clearTimeout(tt);tt=setTimeout(()=>t.hidden=true,2800);}

/* ---------- floor guide ---------- */
function drawGuide(){
  const y=cv.height*horizon,lw=Math.max(2,cv.width/500),fs=Math.max(13,cv.width/70);
  ctx.save();ctx.setLineDash([lw*6,lw*4]);ctx.lineWidth=lw;ctx.strokeStyle='#a0552b';ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(cv.width,y);ctx.stroke();ctx.setLineDash([]);
  const label='EYE LEVEL · DRAG TO WHERE THE HORIZON WOULD BE';ctx.font=`400 ${fs}px Jost, sans-serif`;const w=ctx.measureText(label).width+fs*1.4;
  ctx.fillStyle='#a0552b';ctx.fillRect(fs,y-fs*1.1,w,fs*2.2);ctx.fillStyle='#ffffff';ctx.textBaseline='middle';ctx.fillText(label,fs*1.7,y);ctx.restore();
}
function toggleGuide(on){guideOn=on;$('guideBtn').setAttribute('aria-pressed',on);$('guideBtn').classList.toggle('on',on);
  if(on)toast('Drag the dashed line to eye level. Pieces then shrink as you move them back.');draw();}
$('guideBtn').onclick=()=>toggleGuide(!guideOn);

/* ---------- complete settings (offsets in cm: dx across, dz toward the viewer) ---------- */
/* Which photo shows each side of a piece: f front, b back, s side, a angled.
   sR / aR mark a side or angled photo that faces right; the rest face left. */
const V={
 'airlie-180cm-outdoor-sofa':{f:'Front',b:'Back',s:'Side',a:'Angled front'},
 'airlie-outdoor-lounge-chair':{f:'Front',b:'Back',s:'Side',a:'Angled front'},
 'airlie-outdoor-dining-chair':{f:'Front',b:'Back',s:'Side'},
 'kirra-outdoor-3seat-sofa':{f:'Front',s:'Side',a:'Angled front'},
 'kirra-outdoor-lounge-chair':{f:'Front',s:'Side',a:'Angled front'},
 'kirra-outdoor-dining-chair':{f:'Front',b:'Back',s:'Side'},
 'blueys-sofa':{f:'View 1',b:'View 3'},
 'blueys-lounge-chair':{f:'View 3',a:'View 1',s:'View 2',sR:true},
 'cottesloe-sofa':{f:'View 1',b:'View 2'},
 'cottesloe-lounge-chair':{f:'View 1',b:'View 2'},
 'janjuc-sofa':{f:'View 1',b:'View 2'},
 'janjuc-lounge-chair-xl':{f:'View 1',a:'View 2',aR:true},
 'noosa-sofa':{f:'Front'},
 'noosa-lounge-chair':{f:'Front',b:'Back'},
 'capri-3-seat-sofa':{f:'Front'},
 'capri-outdoor-lounge-chair':{f:'Front'},
 'noosa-dining-chair':{f:'View 2',b:'View 3',s:'View 1',sR:true},
 'wategos-dining-chair':{f:'View 1',b:'View 3',s:'View 2'},
 'shelley-dining-chair':{f:'View 1',b:'View 3',s:'View 2'},
 'merricks-dining-chair':{f:'View 1',b:'View 3',s:'View 2'},
 'eden-dining-chair-1':{f:'View 1',b:'View 3',a:'View 1',aR:true},
 'bicheno-dining-chair':{f:'View 1',b:'View 2',a:'View 1'},
 'ningaloo-dining-chair':{f:'Angled front',b:'Angled back',a:'Angled front',aR:true},
 'capri-outdoor-dining-chair':{f:'Front',b:'Back',s:'Side'},
 'mollymook-dining-arm-chair':{f:'View 2',b:'Back',a:'View 1'}
};
/* [range, sofa, lounge chair, coffee table] */
const LOUNGE=[
 ['Airlie','airlie-180cm-outdoor-sofa','airlie-outdoor-lounge-chair','byron-coffee-table-120cm'],
 ['Blueys','blueys-sofa','blueys-lounge-chair','blueys-coffee-table'],
 ['Capri','capri-3-seat-sofa','capri-outdoor-lounge-chair','kiama-coffee-table'],
 ['Cottesloe','cottesloe-sofa','cottesloe-lounge-chair','cottesloe-coffee-table'],
 ['Jan Juc','janjuc-sofa','janjuc-lounge-chair-xl','jan-juc-round-coffee-table'],
 ['Kirra','kirra-outdoor-3seat-sofa','kirra-outdoor-lounge-chair','kiama-coffee-table'],
 ['Noosa','noosa-sofa','noosa-lounge-chair','noosa-coffee-table']
];
/* [range, dining chair, table for 4/6/8 chairs]. Byron tables have true front-on photos, so they sit right on any floor. */
const BYRON={4:'byron-pebble-dining-table-160cm',6:'byron-pebble-dining-table-230cm',8:'byron-pebble-dining-table-280cm'};
const DINING=[
 ['Airlie','airlie-outdoor-dining-chair',BYRON],
 ['Bicheno','bicheno-dining-chair',BYRON],
 ['Capri','capri-outdoor-dining-chair',BYRON],
 ['Eden','eden-dining-chair-1',BYRON],
 ['Kirra','kirra-outdoor-dining-chair',BYRON],
 ['Merricks','merricks-dining-chair',BYRON],
 ['Mollymook armchair','mollymook-dining-arm-chair',BYRON],
 ['Ningaloo','ningaloo-dining-chair',BYRON],
 ['Noosa','noosa-dining-chair',{4:'jan-juc-round-dining-table',6:'janjuc-dining-table-non-slat',8:BYRON[8]}],
 ['Shelley','shelley-dining-chair',BYRON],
 ['Wategos','wategos-dining-chair',{4:'jan-juc-round-dining-table',6:'janjuc-dining-table-non-slat',8:BYRON[8]}]
];
const vw=pid=>V[pid]||{};
/* width in cm of the photo with this label */
function cm(pid,label,ci=0){const p=prod(pid);if(!p)return 0;const A=p.colours[ci].angles,a=A.find(x=>x.label===label)||A[0];return a.ow/p.pxPerCm;}
/* a piece at one end of a setting, turned to face the middle */
function facing(pid,dx,dz,left,order){const v=vw(pid);
  for(const k of order){if(v[k])return[pid,v[k],dx,dz,left?!v[k+'R']:!!v[k+'R']];}
  return[pid,v.f||'',dx,dz];}
function loungeSet(r){const[n,S,C,T]=r,v=vw(S),sw=cm(S,v.f);
  return{name:n+' lounge setting',items:[[S,v.f,0,-90],[T,'',0,40],facing(C,-(sw/2+45),20,true,['a','s']),facing(C,sw/2+45,20,false,['a','s'])]};}
function diningSet(r,n){const[name,C,tables]=r,T=tables[n],v=vw(C);if(!v.b||!(v.s||v.a))return null;
  /* 4: one each side and one at each end; 6: three a side; 8: three a side and one at each end */
  const tw=cm(T,''),cw=cm(C,v.f),per=n===4?1:3,span=per>1?Math.min(tw-cw-30,(per-1)*(cw+30)):0,items=[[T,'',0,0]];
  for(let i=0;i<per;i++){const dx=per>1?-span/2+i*span/(per-1):0;items.push([C,v.f,dx,-85],[C,v.b,dx,85]);}
  if(n!==6)items.push(facing(C,-(tw/2+30),0,true,['s','a']),facing(C,tw/2+30,0,false,['s','a']));
  return{name:`${name} dining for ${n}`,items};}
function renderSets(){const box=$('sets');box.innerHTML='';
  const row=(label,list,opts)=>{const ok=list.filter(r=>prod(r[1]));if(!ok.length)return;
    const w=document.createElement('div');w.className='set-row';
    const lab=document.createElement('span');lab.className='set-label';lab.textContent=label;
    const pick=document.createElement('select');pick.className='set-pick';pick.setAttribute('aria-label',label+' range');
    ok.forEach((r,i)=>{const o=document.createElement('option');o.value=i;o.textContent=r[0];pick.appendChild(o);});
    const btns=document.createElement('div');btns.className='set-btns';
    const paint=()=>{btns.innerHTML='';const r=ok[pick.value];
      opts.forEach(([txt,make])=>{const st=make(r),b=document.createElement('button');b.type='button';b.className='chip';b.textContent=txt;
        if(!st||!st.items.every(i=>prod(i[0]))){b.disabled=true;b.title='Not available in this range yet';}
        else{b.title='Replaces the pieces on your photo with this setting';b.onclick=()=>placeSet(st);}
        btns.appendChild(b);});};
    pick.onchange=paint;w.append(lab,pick,btns);box.appendChild(w);paint();};
  row('Lounge',LOUNGE,[['Sofa, 2 chairs + coffee table',loungeSet]]);
  row('Dining',DINING,[['4 chairs',r=>diningSet(r,4)],['6 chairs',r=>diningSet(r,6)],['8 chairs',r=>diningSet(r,8)]]);
}
async function placeSet(set){
  /* use the first colour of each piece that has every photo the layout needs */
  const need={};set.items.forEach(([pid,label])=>{(need[pid]=need[pid]||new Set()).add(label);});
  const ciOf={};Object.entries(need).forEach(([pid,L])=>{const C=prod(pid).colours,i=C.findIndex(c=>[...L].every(l=>!l||c.angles.some(a=>a.label===l)));ciOf[pid]=i<0?0:i;});
  await ensure(set.items.flatMap(i=>colourKeys(i[0],ciOf[i[0]])));
  items=[];sel=null;
  const H=cv.height,W=cv.width,hz=H*horizon,y0=H*.84,D0=700;
  let s=(y0-hz)/(H*.54)*H*.34/80*((scene&&SCENE_SETSCALE[scene])||1);
  /* shrink big settings so the whole layout fits across the photo */
  const reach=Math.max(...set.items.map(([pid,label,dx,dz])=>(Math.abs(dx)+cm(pid,label,ciOf[pid])/2)*D0/(D0-dz)));
  if(2*reach*s>W*.92)s=W*.92/(2*reach);
  [...set.items].sort((a,b)=>a[3]-b[3]).forEach(([pid,label,dx,dz,flip])=>{
    const ci=ciOf[pid],k=D0/(D0-dz),A=prod(pid).colours[ci].angles;let vi=A.findIndex(a=>a.label===label);if(vi<0)vi=0;
    addItem(pid,{ci,vi,flip:!!flip,x:W*.5+dx*s*k,y:hz+(y0-hz)*k,h:heightFor(pid,ci,vi,s*k)});
  });
  select(null);draw();renderPlaced();toast(set.name+' placed. Drag pieces to fine-tune.');
}

/* ---------- add whole layout to the Shopify cart ---------- */
$('cartBtn').addEventListener('click',async e=>{
  e.preventDefault();const lines=selection().filter(l=>l.vid&&l.available!==false);
  if(!lines.length){toast('Add a piece first.');return;}
  const btn=$('cartBtn');btn.setAttribute('aria-disabled','true');btn.textContent='Adding…';
  try{
    const r=await fetch((window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:lines.map(l=>({id:l.vid,quantity:l.qty,properties:{'_Added from':'See it in your space'}}))})});
    if(!r.ok){const j=await r.json().catch(()=>({}));throw new Error(j.description||'cart');}
    const skipped=selection().length-lines.length;
    toast(skipped?`Added to cart. ${skipped} sold-out piece${skipped>1?'s were':' was'} left out.`:'Added to cart.');
    setTimeout(()=>{location.href=(window.Shopify&&Shopify.routes&&Shopify.routes.root||'/')+'cart';},700);
  }catch(err){toast(err.message&&err.message!=='cart'?err.message:'Those pieces could not be added to your cart. Try again, or add them from each product page.');}
  finally{btn.textContent='Add all to cart';btn.setAttribute('aria-disabled','false');}
});

/* ---------- lead capture → Klaviyo ---------- */
function openLead(){if(!items.length){toast('Add a piece first.');return;}$('saveBtn').click();setTimeout(()=>$('leadName').focus(),50);}
$('leadBtn').onclick=openLead;
async function klaviyo(path,payload){
  const r=await fetch('https://a.klaviyo.com/client/'+path+'/?company_id='+encodeURIComponent(CFG.klaviyoKey),{method:'POST',headers:{'Content-Type':'application/json',revision:'2025-01-15'},body:JSON.stringify(payload)});
  if(!r.ok&&r.status!==202)throw new Error('klaviyo '+r.status);
}
$('leadForm').addEventListener('submit',async e=>{
  e.preventDefault();const msg=$('leadMsg');msg.className='lead-msg';
  const name=$('leadName').value.trim(),email=$('leadEmail').value.trim(),pc=$('leadPostcode').value.trim(),optIn=$('leadOptIn').checked;
  if(!name){msg.className='lead-msg err';msg.textContent='Add your name so we know who to address the email to.';return;}
  if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){msg.className='lead-msg err';msg.textContent='Check your email address. It needs an @ and a domain, like name@example.com.';return;}
  if(pc&&!/^\d{4}$/.test(pc)){msg.className='lead-msg err';msg.textContent='Australian postcodes are 4 digits.';return;}
  if(!CFG.klaviyoKey){msg.className='lead-msg err';msg.textContent='Emailing designs is not switched on yet. Call 0478 111 787 and we can help.';return;}
  const lines=selection(),total=lines.reduce((a,l)=>a+l.qty*l.price,0),first=name.split(' ')[0],last=name.split(' ').slice(1).join(' ');
  const items_=lines.map(l=>({ProductName:l.p.name,Colour:l.colour,Quantity:l.qty,ItemPrice:l.price,RowTotal:l.qty*l.price,ProductURL:location.origin+l.p.url,ImageURL:l.p.thumb?(l.p.thumb.startsWith('//')?'https:'+l.p.thumb:l.p.thumb):'',VariantID:l.vid}));
  $('leadSubmit').disabled=true;
  try{
    await klaviyo('events',{data:{type:'event',attributes:{
      metric:{data:{type:'metric',attributes:{name:'Saved Furniture Design'}}},
      properties:{Items:items_,ItemNames:items_.map(i=>i.ProductName),Total:total,PieceCount:lines.reduce((a,l)=>a+l.qty,0),Scene:scene||'Own photo',SourcePage:location.href,CartURL:location.origin+'/cart/'+lines.filter(l=>l.vid).map(l=>l.vid+':'+l.qty).join(',')},
      value:total,
      profile:{data:{type:'profile',attributes:{email,first_name:first,last_name:last||undefined,location:pc?{zip:pc,country:'Australia'}:undefined,properties:{'SIYS Last Design Total':total}}}}}}});
    if(optIn&&CFG.klaviyoList){
      // A failed news sign-up must not hide that the design was sent.
      await klaviyo('subscriptions',{data:{type:'subscription',attributes:{custom_source:'See it in your space',profile:{data:{type:'profile',attributes:{email,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:CFG.klaviyoList}}}}}).catch(()=>{});
    }
    msg.className='lead-msg ok';msg.textContent=`Thanks ${first}. We're emailing your design to ${email} now.`;
    $('leadForm').reset();
  }catch(err){msg.className='lead-msg err';msg.textContent='Your design could not be sent just now. Check your connection and try again.';}
  finally{$('leadSubmit').disabled=false;}
});

/* ---------- AI: make it photo-real ---------- */
$('realBtn').onclick=async()=>{
  if(!items.length){toast('Add a piece first.');return;}
  if(!CFG.aiEndpoint){$('aiModal').hidden=false;return;}
  const btn=$('realBtn');btn.disabled=true;btn.textContent='Blending… about 20 seconds';
  try{
    draw.exporting=true;draw();const image=cv.toDataURL('image/jpeg',.88);draw.exporting=false;draw();
    const r=await fetch(CFG.aiEndpoint,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({image,items:selection().map(l=>({name:l.p.name,colour:l.colour,qty:l.qty}))})});
    const j=await r.json();if(!r.ok||!j.image)throw new Error(j.error||'ai');
    $('outImg').src=j.image;$('modal').hidden=false;
  }catch(err){toast('The photo-real version could not be made just now. Your layout is unchanged.');}
  finally{btn.disabled=false;btn.textContent='Make it photo-real';}
};
$('closeAi').onclick=()=>{$('aiModal').hidden=true;};
// Photo-real stays hidden until an image service URL is set in the section settings.
if(!CFG.aiEndpoint){const rb=$('realBtn');rb.hidden=true;if(rb.parentElement&&rb.parentElement.classList.contains('ai-row'))rb.parentElement.hidden=true;}

/* ---------- boot ---------- */
(async()=>{
  PRODUCTS=CFG.live.map(l=>{const c=CUT.p[l.handle];if(!c)return null;
    const cols=c.c.map(col=>{const vt=col.n==='Standard'?'Default Title':col.n;const v=l.variants.find(v=>v.title===vt)||(l.variants.length===1?l.variants[0]:null);if(!v)return null;
      return{name:col.n,price:v.price/100,vid:v.id,available:v.available,angles:col.a.map(a=>({label:a[0],key:a[1],ow:a[2],oh:a[3]}))};}).filter(Boolean);
    if(!cols.length)return null;
    cols.sort((a,b)=>(b.available===true)-(a.available===true));
    return{id:l.handle,name:l.title,type:l.type||c.t,url:l.url,thumb:l.image,pxPerCm:c.ppc,colours:cols};}).filter(Boolean);
  if(!PRODUCTS.length){$('hint').textContent='Pieces could not be loaded. Refresh the page to try again.';return;}
  {const own=CFG.product&&prod(CFG.product);if(own)rng=rangeOf(own);}
  renderRanges();renderCats();renderProds();renderScenes();renderSets();
  await useScene('olive-grove-courtyard');
  if(!bg)setBackground(sampleScene());
  const H=cv.height,W=cv.width,s0=H*.36/80;
  const vIdx=(pid,label)=>{const a=prod(pid).colours[0].angles.findIndex(a=>a.label===label);return a<0?0:a;};
  const deep=CFG.product||decodeURIComponent(location.hash.slice(1));
  if(deep&&prod(deep)){await ensure(colourKeys(deep,0));const p=prod(deep),vi=Math.max(0,p.colours[0].angles.findIndex(a=>a.label==='Angled front'));addItem(deep,{x:W*.5,y:H*.88,vi,h:heightFor(deep,0,vi,s0)});renderPlaced();draw();toast(p.name+' is ready. Upload a photo of your space to see it at home.');return;}
  const start=[['airlie-180cm-outdoor-sofa',{x:W*.56,y:H*.72},.6],['airlie-outdoor-lounge-chair',{x:W*.82,y:H*.88,flip:true},.72]].filter(s=>prod(s[0]));
  await ensure(start.flatMap(s=>colourKeys(s[0],0)));
  start.forEach(([pid,o,k])=>{const vi=vIdx(pid,'Angled front');addItem(pid,Object.assign(o,{vi,h:heightFor(pid,0,vi,s0*k)}));});
  select(null);draw();renderPlaced();
})();

})();
